module.exports = __webpack_public_path__ + "static/media/spin_cash100.50b97abb.png";